import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { List, ListDivider } from 'react-toolbox/lib/list'

import ApprovalItem from './ApprovalItem'

import theme from './ApprovalList.scss'

class ApprovalList extends Component {
  createApprovalListItems(){
    let { approvals, currentApproval, ...props } = this.props
    let lastApprovalIndex = approvals.length - 1

    let approvalListItems =  approvals.reduce((array, approval, index) => {
      const isSelected = currentApproval && (currentApproval.id === approval.id)
      array.push(
        <ApprovalItem
          selected={isSelected}
          key={approval.id}
          approval={ approval }
          {...props}
        />
      )

      if( index !== lastApprovalIndex ) array.push(<ListDivider key={ 'divider_' + index }/>)

      return array
    }, [])

    return approvalListItems
  }

  render() {
    return (
      <List selectable theme={theme}>
        {this.createApprovalListItems()}
      </List>
    )
  }
}

ApprovalList.propTypes = {
  approvals: PropTypes.array.isRequired,
  rejectApproval: PropTypes.func.isRequired,
  acceptApproval: PropTypes.func.isRequired,
}

export default CSSModules(ApprovalList, theme)
